module.exports = __webpack_public_path__ + "img/about-workflow.a2f8d703.png";